import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import Wrapper from './wrapper';
import Label from './label';

export const query = graphql`
  fragment StrapiFormInput on STRAPI_ComponentFormsInput {
    id
    name
    label
    placeholder
    required
    type
  }
`;

const Input = ({
  className,
  name,
  label = null,
  placeholder = null,
  required = false,
  type = 'text',
  onChange,
  value,
}) => {
  const Component = type === 'textarea' ? 'textarea' : 'input';
  return (
    <Wrapper>
      {label && <Label required={required}>{label}</Label>}
      <Component
        className={className}
        type={type}
        name={name}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        value={value}
      />
    </Wrapper>
  );
};

export default styled(Input)``;
